import React, { useCallback } from 'react';
// import cn from 'classnames';

import { Button, message, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import {
  useRemoveTutorCertificateMutation,
} from '../../store/apis/administratives/tutors';
import useToggle from '../../hooks/useToggle';

const RemoveCertificate = ({ id }) => {
  const [t] = useTranslation();
  const [isOpen, open, close] = useToggle();
  const [remove, { isLoading, isFetching }] = useRemoveTutorCertificateMutation();

  const removeCertificate = useCallback(async () => {
    try {
      await remove(id).unwrap();
      message.success(t('Сертификат удален'));
      close();
    } catch (e) {
      console.log(JSON.stringify(e, 0, 2));
    }
  }, [close, id, remove, t]);

  return (
    <Popconfirm
      open={isOpen}
      title={t('Вы действительно хотите удалить сертификат?')}
      description={t('Данное действие необратимо')}
      okText={t('Да, удалить')}
      cancelText={t('Нет')}
      onConfirm={removeCertificate}
      onCancel={close}
      okButtonProps={{
        loading: isLoading || isFetching,
      }}
    >
      <Button type="link" danger icon={<DeleteOutlined />} size="small" onClick={open}/>
    </Popconfirm>
  );
};

export default RemoveCertificate;
